// @ts-nocheck

/**
 * * `SUBSCRIPTION` - Recurring Subscription
 * `CREDIT_PACK` - One-Time Credit Pack
 */
export type SubscriptionPlanCategoryEnum =
  typeof SubscriptionPlanCategoryEnum[keyof typeof SubscriptionPlanCategoryEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionPlanCategoryEnum = {
  SUBSCRIPTION: "SUBSCRIPTION",
  CREDIT_PACK: "CREDIT_PACK",
} as const;
